import error from "../../../src/assets/error.svg";
import dashboardTrue from "../../../src/assets/dashboardTrue.svg";
import dashboardCross from "../../../src/assets/dashboardCross.svg";
import pendingReview from "../../../src/assets/pending-review-icon.jpg";
import awaitingSide from "../../../src/assets/awaitingSidebar.svg";

export const chaseStatusData = [
    {
        name: "Failed",
        label: "Failed",
        bgColor: "bg-warn",
        img: error,
        color: "text-warn",
        tile: "bg-[rgba(245,165,36,0.14)] ring-1 ring-inset ring-[rgba(245,165,36,0.38)]",
        wash: "bg-[linear-gradient(90deg,rgba(245,165,36,0.13),transparent)]",
    },
    {
        name: "Cancelled",
        label: "Cancelled",
        bgColor: "bg-alert",
        img: dashboardCross,
        color: "text-[#FFBDBB]",
        tile: "bg-[rgba(229,57,53,0.14)] ring-1 ring-inset ring-[rgba(229,57,53,0.40)]",
        wash: "bg-[linear-gradient(90deg,rgba(229,57,53,0.13),transparent)]",
    },
    {
        name: "Rejected",
        label: "Rejected",
        bgColor: "bg-alert",
        img: dashboardCross,
        color: "text-[#FFBDBB]",
        tile: "bg-[rgba(229,57,53,0.14)] ring-1 ring-inset ring-[rgba(229,57,53,0.40)]",
        wash: "bg-[linear-gradient(90deg,rgba(229,57,53,0.13),transparent)]",
    },
    {
        name: "Approved",
        label: "Approved",
        bgColor: "bg-success",
        img: dashboardTrue,
        color: "text-[#86EFC8]",
        tile: "bg-[rgba(74,222,128,0.12)] ring-1 ring-inset ring-[rgba(74,222,128,0.35)]",
        wash: "bg-[linear-gradient(90deg,rgba(74,222,128,0.12),transparent)]",
    },
    {
        name: "Awaiting-Customer",
        label: "Upload",
        bgColor: "bg-app-link",
        img: awaitingSide,
        color: "text-app-link",
        tile: "bg-[rgba(91,140,255,0.14)] ring-1 ring-inset ring-[rgba(91,140,255,0.40)]",
        wash: "bg-[linear-gradient(90deg,rgba(91,140,255,0.13),transparent)]",
    },
    {
        name: "Pending-Review",
        label: "In Review",
        bgColor: "bg-white/[0.55]",
        img: pendingReview,
        color: "text-white/[0.66]",
        tile: "bg-white/[0.05] ring-1 ring-inset ring-white/[0.12]",
        wash: "bg-[linear-gradient(90deg,rgba(255,255,255,0.05),transparent)]",
    },
    {
        name: "Rebroked",
        label: "Rebroked",
        bgColor: "bg-alert",
        img: dashboardCross,
        color: "text-[#FFBDBB]",
        tile: "bg-[rgba(229,57,53,0.14)] ring-1 ring-inset ring-[rgba(229,57,53,0.40)]",
        wash: "bg-[linear-gradient(90deg,rgba(229,57,53,0.13),transparent)]",
    },
    {
        name: "Mismatched",
        label: "Mismatched",
        bgColor: "bg-alert",
        img: dashboardCross,
        color: "text-[#FFBDBB]",
        tile: "bg-[rgba(229,57,53,0.14)] ring-1 ring-inset ring-[rgba(229,57,53,0.40)]",
        wash: "bg-[linear-gradient(90deg,rgba(229,57,53,0.13),transparent)]",
    }
];
